import { render, staticRenderFns } from "./CollaboratorUserNameAutoComplete.vue?vue&type=template&id=de950cd8&scoped=true&"
import script from "./CollaboratorUserNameAutoComplete.vue?vue&type=script&lang=js&"
export * from "./CollaboratorUserNameAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de950cd8",
  null
  
)

export default component.exports